export function splitAroundCount(text, count) {
    const token = String(count);
    const at = text.indexOf(token);
    if (at < 0) return [
        '',
        '',
        text
    ];
    return [
        text.slice(0, at),
        token,
        text.slice(at + token.length)
    ];
}
